export const CREATE_GROUP_MUTATION = `
  mutation CreateGroup($name: String!, $description: String, $company_id: Int!, $group_manager_id: Int) {
    insert_groups_one(object: {
      name: $name,
      description: $description,
      company_id: $company_id,
      group_manager_id: $group_manager_id
    }) {
      id
      name
      description
      company_id
      group_manager_id
      created_at
      updated_at
    }
  }
`;

export const UPDATE_GROUP_MUTATION = `
  mutation UpdateGroup($id: Int!, $name: String!, $description: String, $company_id: Int, $group_manager_id: Int) {
    update_groups_by_pk(pk_columns: { id: $id }, _set: {
      name: $name,
      description: $description,
      company_id: $company_id,
      group_manager_id: $group_manager_id
    }) {
      id
      name
      description
      company_id
      group_manager_id
      created_at
      updated_at
    }
  }
`;

export const DELETE_GROUP_MUTATION = `
  mutation DeleteGroup($id: Int!) {
    delete_groups_by_pk(id: $id) {
      id
      name
    }
  }
`;

 